const init = () => ({ purpose: null })
const set = purpose => ({ purpose })

const purposeState = { init, set }
export default purposeState
